module.exports = __webpack_public_path__ + "static/img/54.06728a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/Music/GoodsShow/AirPods Pro/imgs/second/54.jpg
// module id = 4mOt
// module chunks = 0